import { render, staticRenderFns } from "./TopbarHorizontal.vue?vue&type=template&id=056f2692&"
import script from "./TopbarHorizontal.vue?vue&type=script&lang=js&"
export * from "./TopbarHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports